import React from "react";
import { Modal, DatePicker } from "antd";
import moment from "moment";

export const LoanItemModal = ({
  title,
  open,
  handleCancel,
  handleChange,
  data,
  handleSave,
}) => {
  return (
    <div>
      <Modal
        visible={open}
        footer={null}
        onOk={handleCancel}
        onCancel={handleCancel}
        closable={false}
        centered
      >
        <div style={{ display: "flex", gap: "1rem", alignItems: "center" }}>
          <h3 className="modaltitle">{title}</h3>
        </div>
        <div
          style={{
            maxHeight: "25rem",
            overflow: "scroll",
            padding: "8px",
          }}
        >
          <div style={{ marginBottom: "8px" }}>
            <h3 className="inputTitle">Borrower Name <span style={{ color: "red" }}>*</span></h3>
            <input
              className="roleInput"
              placeholder="Borrower Name"
              name="borrowerName"
              value={data && data.borrowerName}
              id="borrowerName"
              onChange={(e) => {
                e.preventDefault();
                handleChange("borrowerName", e.target.value);
              }}
            />
          </div>
          <div style={{ marginBottom: "8px" }}>
            <h3 className="inputTitle">Borrower Phone Number  <span style={{ color: "red" }}>*</span></h3>
            <input
              className="roleInput"
              placeholder="Borrower Phone Number"
              name="borrowerPhoneNumber"
              value={data && data.borrowerPhoneNumber}
              id="borrowerPhoneNumber"
              onChange={(e) => {
                e.preventDefault();
                handleChange("borrowerPhoneNumber", e.target.value);
              }}
            />
          </div>
          <div style={{ marginBottom: "8px" }}>
            <h3 className="inputTitle">
              Borrow Date <span style={{ color: "red" }}>*</span>
            </h3>
            <DatePicker
              style={{
                width: "100%",
                border: "1px solid #d1d5db",
                borderRadius: "5px",
              }}
              size="large"
              format={"MM/DD/YYYY"}
              placeholder="Borrow Date"
              name="borrowDate"
              value={data && data.borrowDate && moment.utc(data.borrowDate)}
              id="newDate"
              onChange={(date, dateString) => {
                handleChange("borrowDate", dateString);
              }}
            />
          </div>
          <div style={{ marginBottom: "8px" }}>
            <h3 className="inputTitle">
              Return Date <span style={{ color: "red" }}>*</span>
            </h3>
            <DatePicker
              style={{
                width: "100%",
                border: "1px solid #d1d5db",
                borderRadius: "5px",
              }}
              size="large"
              format={"MM/DD/YYYY"}
              placeholder="Return Date"
              name="returnDate"
              value={data && data.returnDate && moment.utc(data.returnDate)}
              id="newDate"
              onChange={(date, dateString) => {
                handleChange("returnDate", dateString);
              }}
            />
          </div>
          <div style={{ marginBottom: "8px" }}>
            <h3 className="inputTitle">Details</h3>
            <input
              className="roleInput"
              placeholder="Enter Details Here"
              name="details"
              value={data && data.details}
              id="details"
              onChange={(e) => {
                e.preventDefault();
                handleChange("details", e.target.value);
              }}
            />
          </div>
        </div>
        <div className="buttonsMain">
          <button
            className="cancelbutton"
            onClick={() => {
              handleCancel();
            }}
          >
            Cancel
          </button>
          <button
            className="savebutton"
            disabled={!data || !data.borrowDate || !data.returnDate || !data.borrowerName || !data.borrowerPhoneNumber}
            onClick={() => {
              handleSave();
            }}
          >
            Save
          </button>
        </div>
      </Modal>
    </div>
  );
};
